import dynamic from "next/dynamic";

import { SingleColorIconSelections } from "@brexhq/shared/types/SingleColorIcons";

//FIXME: This uses next/dynamic and should live in /next, but Sanity currently uses it to render Icons.
const allSingleColorIcons: Record<
  typeof SingleColorIconSelections[number],
  any
> = {
  ArrowDiagonal: dynamic(
    () => import("@brexhq/shared/assets/icons/single-color/ArrowDiagonal"),
  ),
  ArrowRightDisplay: dynamic(
    () => import("@brexhq/shared/assets/icons/single-color/ArrowRightDisplay"),
  ),
  ArrowRight: dynamic(
    () => import("@brexhq/shared/assets/icons/single-color/ArrowRight"),
  ),
  Carat: dynamic(
    () => import("@brexhq/shared/assets/icons/single-color/Carat"),
  ),
  CheckCircle: dynamic(
    () => import("@brexhq/shared/assets/icons/single-color/CheckCircle"),
  ),
  CircleCheckFilled: dynamic(
    () => import("@brexhq/shared/assets/icons/single-color/CircleCheckFilled"),
  ),
  CircleCheckMark: dynamic(
    () => import("@brexhq/shared/assets/icons/single-color/CircleCheckMark"),
  ),
  CircleCheckOutlined: dynamic(
    () =>
      import("@brexhq/shared/assets/icons/single-color/CircleCheckOutlined"),
  ),
  CirclePlus: dynamic(
    () => import("@brexhq/shared/assets/icons/single-color/CirclePlus"),
  ),
  Clock: dynamic(
    () => import("@brexhq/shared/assets/icons/single-color/Clock"),
  ),
  DesignSolution: dynamic(
    () => import("@brexhq/shared/assets/icons/single-color/DesignSolution"),
  ),
  Dollar: dynamic(
    () => import("@brexhq/shared/assets/icons/single-color/Dollar"),
  ),
  Grow: dynamic(() => import("@brexhq/shared/assets/icons/single-color/Grow")),
  Handshake: dynamic(
    () => import("@brexhq/shared/assets/icons/single-color/Handshake"),
  ),
  Keys: dynamic(() => import("@brexhq/shared/assets/icons/single-color/Keys")),
  LightningBolt: dynamic(
    () => import("@brexhq/shared/assets/icons/single-color/LightningBolt"),
  ),
  LockShield: dynamic(
    () => import("@brexhq/shared/assets/icons/single-color/LockShield"),
  ),
  MenuClose: dynamic(
    () => import("@brexhq/shared/assets/icons/single-color/MenuClose"),
  ),
  MenuOpen: dynamic(
    () => import("@brexhq/shared/assets/icons/single-color/MenuOpen"),
  ),
  MenuGrid: dynamic(
    () => import("@brexhq/shared/assets/icons/single-color/MenuGrid"),
  ),
  NoEntry: dynamic(
    () => import("@brexhq/shared/assets/icons/single-color/NoEntry"),
  ),
  Outgoing: dynamic(
    () => import("@brexhq/shared/assets/icons/single-color/Outgoing"),
  ),
  RebirthNavBarLogo: dynamic(
    () => import("@brexhq/shared/assets/icons/single-color/RebirthNavBarLogo"),
  ),
  Receipt: dynamic(
    () => import("@brexhq/shared/assets/icons/single-color/Receipt"),
  ),
  Shield: dynamic(
    () => import("@brexhq/shared/assets/icons/single-color/Shield"),
  ),
  SingleCard: dynamic(
    () => import("@brexhq/shared/assets/icons/single-color/SingleCard"),
  ),
  Stopwatch: dynamic(
    () => import("@brexhq/shared/assets/icons/single-color/Stopwatch"),
  ),
  Tick: dynamic(() => import("@brexhq/shared/assets/icons/single-color/Tick")),
  VideoPlay: dynamic(
    () => import("@brexhq/shared/assets/icons/single-color/VideoPlay"),
  ),
  VideoPlayOutlined: dynamic(
    () => import("@brexhq/shared/assets/icons/single-color/VideoPlayOutlined"),
  ),
  VideoPlayPlain: dynamic(
    () => import("@brexhq/shared/assets/icons/single-color/VideoPlayPlain"),
  ),
  XMark: dynamic(
    () => import("@brexhq/shared/assets/icons/single-color/XMark"),
  ),
  ArrowUp: dynamic(
    () => import("@brexhq/shared/assets/icons/single-color/ArrowUp"),
  ),
  Award: dynamic(
    () => import("@brexhq/shared/assets/icons/single-color/Award"),
  ),
  Calendar: dynamic(
    () => import("@brexhq/shared/assets/icons/single-color/Calendar"),
  ),
  CardManagement: dynamic(
    () => import("@brexhq/shared/assets/icons/single-color/CardManagement"),
  ),
  CardSecurity: dynamic(
    () => import("@brexhq/shared/assets/icons/single-color/CardSecurity"),
  ),
  Cash: dynamic(() => import("@brexhq/shared/assets/icons/single-color/Cash")),
  Checkbox: dynamic(
    () => import("@brexhq/shared/assets/icons/single-color/Checkbox"),
  ),
  Checkmark: dynamic(
    () => import("@brexhq/shared/assets/icons/single-color/Checkmark"),
  ),
  ChevronLeft: dynamic(
    () => import("@brexhq/shared/assets/icons/single-color/ChevronLeft"),
  ),
  ChevronRight: dynamic(
    () => import("@brexhq/shared/assets/icons/single-color/ChevronRight"),
  ),
  Clipboard: dynamic(
    () => import("@brexhq/shared/assets/icons/single-color/Clipboard"),
  ),
  Close: dynamic(
    () => import("@brexhq/shared/assets/icons/single-color/Close"),
  ),
  CloseBanner: dynamic(
    () => import("@brexhq/shared/assets/icons/single-color/CloseBanner"),
  ),
  Database: dynamic(
    () => import("@brexhq/shared/assets/icons/single-color/Database"),
  ),
  Exchange: dynamic(
    () => import("@brexhq/shared/assets/icons/single-color/Exchange"),
  ),
  Facebook: dynamic(
    () => import("@brexhq/shared/assets/icons/single-color/Facebook"),
  ),
  Hamburger: dynamic(
    () => import("@brexhq/shared/assets/icons/single-color/Hamburger"),
  ),
  Instagram: dynamic(
    () => import("@brexhq/shared/assets/icons/single-color/Instagram"),
  ),
  Link: dynamic(() => import("@brexhq/shared/assets/icons/single-color/Link")),
  Linkedin: dynamic(
    () => import("@brexhq/shared/assets/icons/single-color/Linkedin"),
  ),
  Lock: dynamic(() => import("@brexhq/shared/assets/icons/single-color/Lock")),
  Management: dynamic(
    () => import("@brexhq/shared/assets/icons/single-color/Management"),
  ),
  Notify: dynamic(
    () => import("@brexhq/shared/assets/icons/single-color/Notify"),
  ),
  Notifyunread: dynamic(
    () => import("@brexhq/shared/assets/icons/single-color/Notifyunread"),
  ),
  Office: dynamic(
    () => import("@brexhq/shared/assets/icons/single-color/Office"),
  ),
  Play: dynamic(() => import("@brexhq/shared/assets/icons/single-color/Play")),
  PrimaryCircle: dynamic(
    () => import("@brexhq/shared/assets/icons/single-color/PrimaryCircle"),
  ),
  RebirthLogo: dynamic(
    () => import("@brexhq/shared/assets/icons/single-color/RebirthLogo"),
  ),
  Reconcilation: dynamic(
    () => import("@brexhq/shared/assets/icons/single-color/Reconcilation"),
  ),
  Rewards: dynamic(
    () => import("@brexhq/shared/assets/icons/single-color/Rewards"),
  ),
  Settings: dynamic(
    () => import("@brexhq/shared/assets/icons/single-color/Settings"),
  ),
  Statement: dynamic(
    () => import("@brexhq/shared/assets/icons/single-color/Statement"),
  ),
  Support: dynamic(
    () => import("@brexhq/shared/assets/icons/single-color/Support"),
  ),
  Sync: dynamic(() => import("@brexhq/shared/assets/icons/single-color/Sync")),
  Team: dynamic(() => import("@brexhq/shared/assets/icons/single-color/Team")),
  Twitter: dynamic(
    () => import("@brexhq/shared/assets/icons/single-color/Twitter"),
  ),
  User: dynamic(() => import("@brexhq/shared/assets/icons/single-color/User")),
  XCircle: dynamic(
    () => import("@brexhq/shared/assets/icons/single-color/XCircle"),
  ),
  Youtube: dynamic(
    () => import("@brexhq/shared/assets/icons/single-color/Youtube"),
  ),
};

export default allSingleColorIcons;
